import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface CounselingSearch {
  corporateNumber: string;
  companyName: string;
  negotiationStatus: string;
  timestamp: number;
}

const initialState = {} as CounselingSearch;

const counselingSearchConditionSlice = createSlice({
  name: "counselings",
  initialState,
  reducers: {
    createCounselingSearchCondition: (
      state,
      action: PayloadAction<CounselingSearch>
    ) => {
      const { corporateNumber, companyName, negotiationStatus, timestamp } =
        action.payload;
      state.corporateNumber = corporateNumber;
      state.companyName = companyName;
      state.negotiationStatus = negotiationStatus;
      state.timestamp = timestamp;
    },
  },
});

export const { createCounselingSearchCondition } =
  counselingSearchConditionSlice.actions;

export default counselingSearchConditionSlice.reducer;
